var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"mb-0"},[(_vm.rule(_vm.value) === true)?_c('v-icon',{attrs:{"color":"success"}},[_vm._v(" mdi-check ")]):_c('v-icon',{attrs:{"color":"error"}},[_vm._v("mdi-close")]),_c('span',{staticClass:"ml-1",domProps:{"innerHTML":_vm._s(_vm.text)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }